export const languageSuggestions = {
  vi: {
    message: 'Trang này cũng có phiên bản tiếng Việt.',
    action: 'Đọc bằng tiếng Việt',
    dismiss: 'Để sau',
  },
  en: {
    message: 'This page is also available in English.',
    action: 'Read in English',
    dismiss: 'Not now',
  },
  ru: {
    message: 'Эта страница доступна на русском.',
    action: 'Открыть на русском',
    dismiss: 'Не сейчас',
  },
  es: {
    message: 'Esta página también está disponible en español.',
    action: 'Leer en español',
    dismiss: 'Ahora no',
  },
  pt: {
    message: 'Esta página também está disponível em português.',
    action: 'Ler em português',
    dismiss: 'Agora não',
  },
  'zh-CN': {
    message: '此页面也有简体中文版。',
    action: '阅读简体中文',
    dismiss: '暂时不用',
  },
  'zh-TW': {
    message: '此頁面也有繁體中文版。',
    action: '閱讀繁體中文',
    dismiss: '暫時不用',
  },
};
